import { EntitySelectorsFactory } from "@ngrx/data";
import { ListingServiceOffering } from "./shared/interfaces/ListingServiceOffering";
import { createSelector } from "@ngrx/store";

export const listingServiceOffering = new EntitySelectorsFactory().create<ListingServiceOffering>(
	"ListingServiceOffering"
);

const hasServiceOffering = (
	serviceOffering: ListingServiceOffering["serviceOfferingName"],
	listingServiceOfferings: ListingServiceOffering[]
): ListingServiceOffering =>
	listingServiceOfferings.find((lso) => lso.serviceOfferingName === serviceOffering);

export const selectOfferingsByOfferingName = createSelector(
	listingServiceOffering.selectEntities,
	(entities) => entities.map((entity) => entity.serviceOfferingName)
);

const hasAtLeaseOneServiceOffering = (
	offerings: string[],
	listingServiceOfferings: ListingServiceOffering[]
) => {
	const serviceOfferingNames = listingServiceOfferings.map(
		(offering) => offering.serviceOfferingName
	);
	return serviceOfferingNames.some((serviceOffering) => offerings.includes(serviceOffering));
};

export const selectListingServiceOffering = (serviceOfferingName: string) =>
	createSelector(listingServiceOffering.selectEntities, (entities) =>
		hasServiceOffering(serviceOfferingName, entities)
	);

export const selectHasAtLeastOneServiceOffering = (offerings: string[]) =>
	createSelector(listingServiceOffering.selectEntities, (entities) =>
		hasAtLeaseOneServiceOffering(offerings, entities)
	);

export const ALL_MARKETING_OFFERINGS: string[] = ["PostcardMania", "SphereBuilder", "AdBuilder"];
